import { UserService } from "src/app/ui/services/user.service";
import { IIndicatorData } from "./iindicator-data-strategy";

type ProcessIndicatorData = (fiscalNumber: Array<string>) => Promise<IIndicatorData>;

export abstract class AbstractIndicatorStrategy {
  protected async doProcessData(callback: ProcessIndicatorData, userService: UserService): Promise<IIndicatorData> {
    return await callback([]);

    /*
        
        Não usa mais a lógica abaixo pois todos usuários podem ter mais de 1 empresa associada. 
        O backend já faz o controle do que vai ser retornado

        
        const user = userService.getUserProfile().getUser();

        if (user.isAdministrator() || user.isManager()) {
            return await callback([]); 
        }

        const userCompanyFiscalNumber = userService.getLoggedUser().getCompanyFiscalNumber();

        return await callback(userCompanyFiscalNumber);*/
  }
}

export abstract class AbstractIndicatorCompanyStrategy {
  protected async doProcessData(callback: ProcessIndicatorData, userService: UserService): Promise<IIndicatorData> {
    const userCompanyFiscalNumber = userService.getLoggedUser().getCompanyFiscalNumber();
    return await callback(userCompanyFiscalNumber);
  }
}
